import { render, staticRenderFns } from "./ProfileButtonComponent.vue?vue&type=template&id=51f1bc21&scoped=true&"
import script from "./ProfileButtonComponent.vue?vue&type=script&lang=js&"
export * from "./ProfileButtonComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f1bc21",
  null
  
)

export default component.exports